export default __webpack_public_path__ + "static/batiments2b_pruned_nocenter-9b5aced19ae097f181ce19328df51d6a.webp";